import { FAQ } from "./FAQ";

export { FAQ };
